import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { ReclassifyWizardContainer } from './reclassify-wizard-container';
import { COADisplayAccount } from '../../../../chart-of-accounts/types';

interface ReclassifyAccountSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  accountToReclassify?: COADisplayAccount;
}

export const ReclassifyAccountSidebar = ({ isOpen, onClose, accountToReclassify }: ReclassifyAccountSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="common.reclassify" defaultMessage="Reclassify" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <ReclassifyWizardContainer onClose={onClose} accountToReclassify={accountToReclassify} />
  </Sidebar>
);
